import { render, staticRenderFns } from "./AddClassroom.vue?vue&type=template&id=e12e6432&scoped=true"
import script from "./AddClassroom.vue?vue&type=script&lang=js"
export * from "./AddClassroom.vue?vue&type=script&lang=js"
import style0 from "./AddClassroom.vue?vue&type=style&index=0&id=e12e6432&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12e6432",
  null
  
)

export default component.exports